import React, { useState } from 'react';
import { maskSensitiveId, normalizeIdInput } from '../../utils/maskSensitiveId';

type MaskedIdFieldProps = {
  id?: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  helperText?: string;
  placeholder?: string;
};

/**
 * ID / passport field: full value visible while focused (catch typos);
 * on blur only last 4 digits/characters are shown.
 */
export const MaskedIdField: React.FC<MaskedIdFieldProps> = ({
  id,
  label,
  value,
  onChange,
  required,
  helperText,
  placeholder,
}) => {
  const [focused, setFocused] = useState(false);
  const displayValue = focused ? value : maskSensitiveId(value);

  return (
    <div>
      <label htmlFor={id} className="mb-1 block text-xs font-medium text-gray-600">
        {label}
      </label>
      <input
        id={id}
        type="text"
        inputMode="text"
        autoComplete="off"
        required={required}
        value={displayValue}
        placeholder={placeholder}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={(e) => {
          if (!focused) return;
          onChange(normalizeIdInput(e.target.value));
        }}
        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm font-mono tracking-wide"
        aria-describedby={helperText ? `${id}-help` : undefined}
      />
      {helperText ? (
        <p id={`${id}-help`} className="mt-1 text-xs text-[var(--muted-foreground)] leading-snug">
          {helperText}
          {!focused && value ? ' Only the last 4 characters are shown when you leave this field.' : ''}
        </p>
      ) : null}
    </div>
  );
};

export default MaskedIdField;
